import styled from "styled-components";

export const ChatFooterContainer =
  styled.div((props) => props?.theme?.themeConfig?.chatFooter?.styles);